/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import * as axios from 'axios';
import type {
  AxiosError,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

import type {
  AllTargetAttributesDto,
  GetPossibleAttributeValuesParams,
  PerTargetAttributesDto,
  TargetAttributeEnumDto,
  UpdateTargetAttribtesRequestDto,
  VehicleTypeDto
} from '../../model';





/**
 * @summary Update target attributes
 */
export const updateTargetAttributes = (
    updateTargetAttribtesRequestDto: UpdateTargetAttribtesRequestDto, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<void>> => {
    
    
    return axios.default.post(
      `/api/v1.1/targetattributes/updateAttributes`,
      updateTargetAttribtesRequestDto,options
    );
  }



export const getUpdateTargetAttributesMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTargetAttributes>>, TError,{data: UpdateTargetAttribtesRequestDto}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof updateTargetAttributes>>, TError,{data: UpdateTargetAttribtesRequestDto}, TContext> => {

const mutationKey = ['updateTargetAttributes'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTargetAttributes>>, {data: UpdateTargetAttribtesRequestDto}> = (props) => {
          const {data} = props ?? {};

          return  updateTargetAttributes(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateTargetAttributesMutationResult = NonNullable<Awaited<ReturnType<typeof updateTargetAttributes>>>
    export type UpdateTargetAttributesMutationBody = UpdateTargetAttribtesRequestDto
    export type UpdateTargetAttributesMutationError = AxiosError<unknown>

    /**
 * @summary Update target attributes
 */
export const useUpdateTargetAttributes = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTargetAttributes>>, TError,{data: UpdateTargetAttribtesRequestDto}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateTargetAttributes>>,
        TError,
        {data: UpdateTargetAttribtesRequestDto},
        TContext
      > => {

      const mutationOptions = getUpdateTargetAttributesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @deprecated
 * @summary Target attributes getter
 */
export const getTargetAttributes = (
    getTargetAttributesBody: number[], options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PerTargetAttributesDto>> => {
    
    
    return axios.default.post(
      `/api/v1.1/targetattributes/getAttributes`,
      getTargetAttributesBody,options
    );
  }



export const getGetTargetAttributesMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTargetAttributes>>, TError,{data: number[]}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof getTargetAttributes>>, TError,{data: number[]}, TContext> => {

const mutationKey = ['getTargetAttributes'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getTargetAttributes>>, {data: number[]}> = (props) => {
          const {data} = props ?? {};

          return  getTargetAttributes(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetTargetAttributesMutationResult = NonNullable<Awaited<ReturnType<typeof getTargetAttributes>>>
    export type GetTargetAttributesMutationBody = number[]
    export type GetTargetAttributesMutationError = AxiosError<unknown>

    /**
 * @deprecated
 * @summary Target attributes getter
 */
export const useGetTargetAttributes = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getTargetAttributes>>, TError,{data: number[]}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getTargetAttributes>>,
        TError,
        {data: number[]},
        TContext
      > => {

      const mutationOptions = getGetTargetAttributesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Target attributes getter
 */
export const getCommonTargetAttributes = (
    getCommonTargetAttributesBody: number[], options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PerTargetAttributesDto>> => {
    
    
    return axios.default.post(
      `/api/v1.1/targetattributes/getAttributes/common`,
      getCommonTargetAttributesBody,options
    );
  }



export const getGetCommonTargetAttributesMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getCommonTargetAttributes>>, TError,{data: number[]}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof getCommonTargetAttributes>>, TError,{data: number[]}, TContext> => {

const mutationKey = ['getCommonTargetAttributes'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getCommonTargetAttributes>>, {data: number[]}> = (props) => {
          const {data} = props ?? {};

          return  getCommonTargetAttributes(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetCommonTargetAttributesMutationResult = NonNullable<Awaited<ReturnType<typeof getCommonTargetAttributes>>>
    export type GetCommonTargetAttributesMutationBody = number[]
    export type GetCommonTargetAttributesMutationError = AxiosError<unknown>

    /**
 * @summary Target attributes getter
 */
export const useGetCommonTargetAttributes = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getCommonTargetAttributes>>, TError,{data: number[]}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getCommonTargetAttributes>>,
        TError,
        {data: number[]},
        TContext
      > => {

      const mutationOptions = getGetCommonTargetAttributesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Target attributes getter
 */
export const getAllTargetAttributes = (
    getAllTargetAttributesBody: number[], options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AllTargetAttributesDto[]>> => {
    
    
    return axios.default.post(
      `/api/v1.1/targetattributes/getAttributes/all`,
      getAllTargetAttributesBody,options
    );
  }



export const getGetAllTargetAttributesMutationOptions = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getAllTargetAttributes>>, TError,{data: number[]}, TContext>, axios?: AxiosRequestConfig}
): UseMutationOptions<Awaited<ReturnType<typeof getAllTargetAttributes>>, TError,{data: number[]}, TContext> => {

const mutationKey = ['getAllTargetAttributes'];
const {mutation: mutationOptions, axios: axiosOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, axios: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getAllTargetAttributes>>, {data: number[]}> = (props) => {
          const {data} = props ?? {};

          return  getAllTargetAttributes(data,axiosOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type GetAllTargetAttributesMutationResult = NonNullable<Awaited<ReturnType<typeof getAllTargetAttributes>>>
    export type GetAllTargetAttributesMutationBody = number[]
    export type GetAllTargetAttributesMutationError = AxiosError<unknown>

    /**
 * @summary Target attributes getter
 */
export const useGetAllTargetAttributes = <TError = AxiosError<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getAllTargetAttributes>>, TError,{data: number[]}, TContext>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getAllTargetAttributes>>,
        TError,
        {data: number[]},
        TContext
      > => {

      const mutationOptions = getGetAllTargetAttributesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * @summary Return vehicle types
 */
export const getVehicleTypes = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<VehicleTypeDto[]>> => {
    
    
    return axios.default.get(
      `/api/v1.1/targetattributes/vehicleTypes`,options
    );
  }




export const getGetVehicleTypesQueryKey = () => {
    return [
    `/api/v1.1/targetattributes/vehicleTypes`
    ] as const;
    }

    
export const getGetVehicleTypesQueryOptions = <TData = Awaited<ReturnType<typeof getVehicleTypes>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleTypes>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVehicleTypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVehicleTypes>>> = ({ signal }) => getVehicleTypes({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getVehicleTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVehicleTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getVehicleTypes>>>
export type GetVehicleTypesQueryError = AxiosError<unknown>


export function useGetVehicleTypes<TData = Awaited<ReturnType<typeof getVehicleTypes>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVehicleTypes>>,
          TError,
          Awaited<ReturnType<typeof getVehicleTypes>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVehicleTypes<TData = Awaited<ReturnType<typeof getVehicleTypes>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getVehicleTypes>>,
          TError,
          Awaited<ReturnType<typeof getVehicleTypes>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVehicleTypes<TData = Awaited<ReturnType<typeof getVehicleTypes>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleTypes>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Return vehicle types
 */

export function useGetVehicleTypes<TData = Awaited<ReturnType<typeof getVehicleTypes>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getVehicleTypes>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVehicleTypesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetVehicleTypesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getVehicleTypes>>, TError = AxiosError<unknown>>( options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVehicleTypes>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetVehicleTypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getVehicleTypes>>> = ({ signal }) => getVehicleTypes({ signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVehicleTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetVehicleTypesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getVehicleTypes>>>
export type GetVehicleTypesSuspenseQueryError = AxiosError<unknown>


export function useGetVehicleTypesSuspense<TData = Awaited<ReturnType<typeof getVehicleTypes>>, TError = AxiosError<unknown>>(
  options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVehicleTypes>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVehicleTypesSuspense<TData = Awaited<ReturnType<typeof getVehicleTypes>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVehicleTypes>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetVehicleTypesSuspense<TData = Awaited<ReturnType<typeof getVehicleTypes>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVehicleTypes>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Return vehicle types
 */

export function useGetVehicleTypesSuspense<TData = Awaited<ReturnType<typeof getVehicleTypes>>, TError = AxiosError<unknown>>(
  options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getVehicleTypes>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetVehicleTypesSuspenseQueryOptions(options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * @summary Return possible target attribute values
 */
export const getPossibleAttributeValues = (
    params: GetPossibleAttributeValuesParams, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TargetAttributeEnumDto[]>> => {
    
    
    return axios.default.get(
      `/api/v1.1/targetattributes/possbileAttributeValues`,{
    ...options,
        params: {...params, ...options?.params},}
    );
  }




export const getGetPossibleAttributeValuesQueryKey = (params?: GetPossibleAttributeValuesParams,) => {
    return [
    `/api/v1.1/targetattributes/possbileAttributeValues`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPossibleAttributeValuesQueryOptions = <TData = Awaited<ReturnType<typeof getPossibleAttributeValues>>, TError = AxiosError<unknown>>(params: GetPossibleAttributeValuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPossibleAttributeValues>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPossibleAttributeValuesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPossibleAttributeValues>>> = ({ signal }) => getPossibleAttributeValues(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPossibleAttributeValues>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPossibleAttributeValuesQueryResult = NonNullable<Awaited<ReturnType<typeof getPossibleAttributeValues>>>
export type GetPossibleAttributeValuesQueryError = AxiosError<unknown>


export function useGetPossibleAttributeValues<TData = Awaited<ReturnType<typeof getPossibleAttributeValues>>, TError = AxiosError<unknown>>(
 params: GetPossibleAttributeValuesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPossibleAttributeValues>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPossibleAttributeValues>>,
          TError,
          Awaited<ReturnType<typeof getPossibleAttributeValues>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPossibleAttributeValues<TData = Awaited<ReturnType<typeof getPossibleAttributeValues>>, TError = AxiosError<unknown>>(
 params: GetPossibleAttributeValuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPossibleAttributeValues>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPossibleAttributeValues>>,
          TError,
          Awaited<ReturnType<typeof getPossibleAttributeValues>>
        > , 'initialData'
      >, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPossibleAttributeValues<TData = Awaited<ReturnType<typeof getPossibleAttributeValues>>, TError = AxiosError<unknown>>(
 params: GetPossibleAttributeValuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPossibleAttributeValues>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Return possible target attribute values
 */

export function useGetPossibleAttributeValues<TData = Awaited<ReturnType<typeof getPossibleAttributeValues>>, TError = AxiosError<unknown>>(
 params: GetPossibleAttributeValuesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPossibleAttributeValues>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPossibleAttributeValuesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetPossibleAttributeValuesSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPossibleAttributeValues>>, TError = AxiosError<unknown>>(params: GetPossibleAttributeValuesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPossibleAttributeValues>>, TError, TData>>, axios?: AxiosRequestConfig}
) => {

const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPossibleAttributeValuesQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPossibleAttributeValues>>> = ({ signal }) => getPossibleAttributeValues(params, { signal, ...axiosOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPossibleAttributeValues>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPossibleAttributeValuesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPossibleAttributeValues>>>
export type GetPossibleAttributeValuesSuspenseQueryError = AxiosError<unknown>


export function useGetPossibleAttributeValuesSuspense<TData = Awaited<ReturnType<typeof getPossibleAttributeValues>>, TError = AxiosError<unknown>>(
 params: GetPossibleAttributeValuesParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPossibleAttributeValues>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPossibleAttributeValuesSuspense<TData = Awaited<ReturnType<typeof getPossibleAttributeValues>>, TError = AxiosError<unknown>>(
 params: GetPossibleAttributeValuesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPossibleAttributeValues>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPossibleAttributeValuesSuspense<TData = Awaited<ReturnType<typeof getPossibleAttributeValues>>, TError = AxiosError<unknown>>(
 params: GetPossibleAttributeValuesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPossibleAttributeValues>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Return possible target attribute values
 */

export function useGetPossibleAttributeValuesSuspense<TData = Awaited<ReturnType<typeof getPossibleAttributeValues>>, TError = AxiosError<unknown>>(
 params: GetPossibleAttributeValuesParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPossibleAttributeValues>>, TError, TData>>, axios?: AxiosRequestConfig}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPossibleAttributeValuesSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




